import { autotraceItemFields } from '@/pages/autotrace/models/autotrace-fields'

export default {
  SET_SHOW_CREATE_EDIT_MODAL(state, payload) {
    state.showCreateEditModal = payload
  },
  SET_MODAL_ACTION(state, payload) {
    state.modalAction = payload
  },
  SET_CREATE_EDIT_MODAL_DATA(state, payload) {
    state.createEditModalData = payload
  },
  SET_INITIAL_CREATE_EDIT_MODAL_DATA(state) {
    state.clearTrigger = !state.clearTrigger
    state.createEditModalData = autotraceItemFields()
  },
  SET_ACTIVE_BLOCKCHAIN(state, payload) {
    state.activeBlockchain = payload
  },
  SET_ACTIVE_TOKEN(state, payload) {
    state.activeToken = payload
  },
  SET_ACTIVE_SEARCH_FIELD(state, payload) {
    state.activeSearchField = payload
  },
  SET_CASE_ACTIVE_TAB(state, payload) {
    state.caseActiveTab = payload
  },
  SET_CASE_INFO(state, payload) {
    state.caseInfo = payload
  },
  SET_CHECKED_ALERTS_MAP(state, payload) {
    state.checkedAlertsMap = payload
  },
  SET_ALERT_CHECKED_STATE(state, { id, value }) {
    state.checkedAlertsMap = {
      ...state.checkedAlertsMap,
      [id]: value
    }
  },
  CLEAR_CHECKED_ALERTS_MAP(state) {
    state.checkedAlertsMap = {}
  },
  SET_CHECKED_ALERTS_COUNT(state, count) {
    state.checkedAlertsCount = count
  },
  INCREMENT_CHECKED_ALERTS_COUNT(state) {
    state.checkedAlertsCount += 1
  },
  DECREMENT_CHECKED_ALERTS_COUNT(state) {
    state.checkedAlertsCount -= 1
  },
  SET_ENTITY_ICON_CACHE(state, { name, src, id }) {
    state.entityIconCache = {
      ...state.entityIconCache,
      [name]: {
        src,
        id,
      }
    }
  },
  ACTIVATE_RELOAD_AUTOTRACE_CASE_TRIGGER(state) {
    state.reloadAutotraceCaseTrigger = Date.now()
  },
}
